import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { ErrorState, LoadingState } from '../../components/ui/Feedback';
import { useHospitalTitle } from '../../lib/hospital-brand';
import { useDocumentHeaderLogo } from '../settings/settings.queries';
import { useIpdDaycareAdmission } from './ipd-daycare.queries';
import { formatIpdDateTime } from './ipd-daycare.utils';

const LABEL_COUNT = 14;
const LABEL_HEADER_NAME = 'bill';

export const IpdPatientLabelsPrintPage = () => {
  const { admissionId } = useParams();
  const admissionQuery = useIpdDaycareAdmission(admissionId);
  const hospitalTitle = useHospitalTitle();
  const headerLogoQuery = useDocumentHeaderLogo(LABEL_HEADER_NAME);

  useEffect(() => {
    if (admissionQuery.data && headerLogoQuery.isFetched) window.setTimeout(() => window.print(), 300);
  }, [admissionQuery.data, headerLogoQuery.isFetched]);

  if (admissionQuery.isLoading) return <LoadingState />;
  if (admissionQuery.isError || !admissionQuery.data) return <ErrorState title="Admission not found" message="The admission could not be loaded." />;

  const admission = admissionQuery.data;
  const patient = admission.patientSnapshot;
  const age = `${patient.ageYears}Y ${patient.ageMonths}M ${patient.ageDays}D`;
  const logo = headerLogoQuery.data;

  return (
    <div className="print-labels-page">
      {Array.from({ length: LABEL_COUNT }).map((_, index) => (
        <div className="print-label" key={index}>
          {logo ? <img className="print-label-logo" src={logo} alt={hospitalTitle} /> : null}
          <p className="print-label-line">Patient Name : <span>{patient.name}</span></p>
          <p className="print-label-line">UHID : <span>{patient.uhid ?? '-'}</span> || Bed : <span>{admission.bedCategory.name} - {admission.bed.name}</span> || Admission Type : <span>{admission.admissionType}</span></p>
          <p className="print-label-line">Sex : <span>{patient.gender}</span> || Age : <span>{age}</span> || Mobile : <span>{patient.phone ?? '-'}</span></p>
          <p className="print-label-line">Address : <span>{patient.address ?? '-'}</span></p>
          <p className="print-label-line">Consultant Doctor : <span>{admission.underDoctor?.name ?? '-'}</span></p>
          <p className="print-label-line">Admission Dt : <span>{formatIpdDateTime(admission.admissionDate)}</span></p>
        </div>
      ))}
    </div>
  );
};
